var React = require('react');

function ConnectFacebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icoConnectFacebook"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"icoConnectFacebook","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M14.6428571,1.13392857 L14.6428571,4.08035714 L12.890625,4.08035714 C12.2507408,4.08035714 11.8191975,4.21428438 11.5959821,4.48214286 C11.3727667,4.75000134 11.2611607,5.15178304 11.2611607,5.6875 L11.2611607,7.796875 L14.53125,7.796875 L14.0959821,11.1004464 L11.2611607,11.1004464 L11.2611607,19.5714286 L7.84598214,19.5714286 L7.84598214,11.1004464 L5,11.1004464 L5,7.796875 L7.84598214,7.796875 L7.84598214,5.36383929 C7.84598214,3.97990379 8.23288304,2.90662584 9.00669643,2.14397321 C9.78050982,1.38132059 10.8110055,1 12.0982143,1 C13.1919698,1 14.0401756,1.04464241 14.6428571,1.13392857 Z","fill":"#FCB34E"}))]);
}

ConnectFacebook.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1"};

module.exports = ConnectFacebook;

ConnectFacebook.default = ConnectFacebook;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/connect-facebook.svg
// module id = 1009
// module chunks = 0